import i18next from 'i18next';

import { LANG_EN } from './lang_en';
import { LANG_RU } from './lang_ru';

/**
 * Формы для русского языка. Для английского к ключу просто добавляется plural
 * key_0:   1, 21, 31, 41, 51, 61, 71, 81, 91
 *
 * key_1:   2, 3, 4, 22, 23, 24, 32, 33, 34, 42, 43, 44, 52, 53, 54, 62, 63, 64,
 *          72, 73, 74, 82, 83, 84, 92, 93, 94
 *
 * key_2:   0, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25,
 *          26, 27, 28, 29, 30, 35, 36, 37, 38, 39, 40, 45, 46, 47, 48, 49, 50,
 *          55, 56, 57, 58, 59, 60, 65, 66, 67, 68, 69, 70, 75, 76, 77, 78, 79,
 *          80, 85, 86, 87, 88, 89, 90, 95, 96, 97, 98, 99, 100
 */

export const I18_READY = new Promise((resolve, reject) => {
    i18next.init({
        'lng': 'ru',
        'resources': {
            'ru': { 'translation': LANG_RU },
            'en': { 'translation': LANG_EN }
        },
        keySeparator: '::',
        'saveMissing': true,
        interpolation: {
            format: function(value, format, lng) {
                if (typeof value === 'number' && format === 'number') {
                    return value.toLocaleString(lng);
                } else {
                    return value;
                }
            }
        }
    }, (err) => {
        if (err) {
            reject(err);
        } else {
            i18next.changeLanguage(window['mapLng'] || getLng()).then(() => {
                resolve();
            });
        }
    });
});
